import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../components/Hyperlink';
import styles from './footer_social.module.scss';

export const FooterSocial: FC = () => (
  <div className="footer__group">
    <Hyperlink className="footer__logo" href="/" source="footer_static_logo">
      <span className="footer__logo__img" />
      <span className="footer__logo__title">
        <FormattedMessage id="footer/components/social/FooterSocial.tsx/1" />
      </span>
    </Hyperlink>
    <div className="footer__group__text">
      <span className="footer__group__text__contact">
        <FormattedMessage id="footer/components/social/FooterSocial.tsx/2" />
      </span>
      <a className="footer__group__list__item" href="tel:+33184803348">
        <FormattedMessage id="footer/components/social/FooterSocial.tsx/3" />
      </a>
    </div>
    <span>
      <a
        className="footer__bottom__social"
        href="https://www.linkedin.com/company/doctrine"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className={styles.icon}
          src="/img/logo/social/linkedin_clear.png"
          alt="linkedin"
        />
      </a>
      <a
        className="footer__bottom__social"
        href="https://twitter.com/doctrine"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className={styles.icon}
          src="/img/logo/social/twitter_clear.png"
          alt="twitter"
        />
      </a>
      <a
        className="footer__bottom__social"
        href="https://www.facebook.com/doctrineFR/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className={styles.icon}
          src="/img/logo/social/facebook_clear.png"
          alt="facebook"
        />
      </a>
      <a
        className="footer__bottom__social"
        href="https://www.youtube.com/c/DoctrineFr"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className={styles.icon}
          src="/img/logo/social/youtube.png"
          alt="youtube"
        />
      </a>
    </span>
  </div>
);
